// extracted by mini-css-extract-plugin
module.exports = {"resultpopup-wrapper":"ResultPopup_resultpopup-wrapper__1JwvC","row":"ResultPopup_row__cpp9-"};